import { AuthFrame } from '../components/auth-frame';
import { MagicLinkCard } from '../components/magic-link-card';

export interface MagicLinkPageProps {
  token: string | undefined;
}

export function MagicLinkPage({ token }: MagicLinkPageProps) {
  return (
    <AuthFrame>
      <MagicLinkCard token={token} />
    </AuthFrame>
  );
}
